import { Box, Modal, Typography, useTheme } from "@mui/material";
import { CustomeModalButton } from "../../../lib/formik/NewFormInputs";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '533px',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    borderRadius: '12px',
    p: '24px',
    ':focus': {
        outline: 'none'
    }
}

export default function TransactionStatusPopup(props: any): JSX.Element {
    const { open, setClose, isLoading, res } = props;
    const { palette } = useTheme();
    return (
        <Modal
            open={open}
            // onClose={handleClose}
            aria-labelledby={"title"}
            aria-describedby={'form-modal'}
        >
            <Box
                sx={style}
            >
                <Typography variant='h2' color={palette.text.primary}>{res.message || 'KYC Status not Found, Would you like to proceed?'}</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', mt: '48px' }}>
                    <CustomeModalButton lookType={'outlined'} btnText={'Cancel'} onClick={() => setClose('cancel')} disabled={isLoading} boxStyle={{ borderRadius: '4px' }} />
                    {res?.transactionStatus &&
                        <CustomeModalButton lookType={'contained'} btnText={'Continue'} disabled={isLoading} onClick={() => setClose('continue')} boxStyle={{ borderRadius: '4px' }} />
                    }
                </Box>
            </Box>
        </Modal >
    )
}